import { apiUrls } from "@/constant/configure";
import api from "@/helpers/api_helper";
import { flatMap, sortBy, uniq, uniqBy } from 'lodash';
import qs from "qs";

interface GetRecommendProductQueryType {
    categoryId: string;
    offset: number;
    limit: number;
}
export const getRecommendProducts = async (userId: string, query: GetRecommendProductQueryType) => {
    try {
        const { categoryId = '', limit = 50, offset = 0 } = query
        const fields = [
            'createdAt', 'groupTitle', 'representImageUrl',
            'id', 'isContracted', 'matchingSponsorshipCondition',
            'representProduct', 'salesClosingDateTime', 'salesOpeningDateTime',
            'tags', 'vendor', 'resaleVendorMarginRate'
        ].join(',')
        const queryStr = `fields=${fields}&${!!categoryId ? `filter=category.id%7C%7C%24eq%7C%7C${categoryId}` : ''}&limit=${limit}&offset=${offset}`
        return await api.get(`/seller/${userId}/products/top?${queryStr}`, {
            baseURL: apiUrls.matching
        }).then(r => {
            return {
                list: r.data?.data || [],
                total: r.data?.total || 0
            }
        })
    } catch (error) { throw error }
}